import { render, staticRenderFns } from "./MultiTripBundling.vue?vue&type=template&id=a4aa1d80&scoped=true&"
import script from "./MultiTripBundling.vue?vue&type=script&lang=js&"
export * from "./MultiTripBundling.vue?vue&type=script&lang=js&"
import style0 from "./MultiTripBundling.vue?vue&type=style&index=0&id=a4aa1d80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4aa1d80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFooter,VImg,VRow})
